export default {
    Search: 'Zoeken',
    'No results found.': 'Geen resultaten gevonden.',
    cancel: 'annuleren'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/addons/searchfield/translations/nl.js
// module id = 517
// module chunks = 0